import { resto, userService } from '@saucelabs/sl-util-axios';

export const searchV11 = (params) => (
  resto.get('/rest/v1.1/archives/search', { params })
);

export const fetchFacet = ({ name, params }) => (
  resto.get(`/rest/v1/archives/facet_search/${name}`, { params })
);

export const getTeams = ({ limit = 99999, offset = 0, ...rest } = {}) => (
  userService.get('/v1/teams/', { params: { limit, offset, ...rest } })
);
